import React from 'react'
import Modal from 'components/Modal'
import Header from 'layouts/PageLayout/Header'
import Footer from 'layouts/PageLayout/Footer'
import BannerSection from 'components/event/BannerSection'
import MissionSection from 'components/event/MissionSection'
import GiftSection from 'components/event/GiftSection'
import swal from "sweetalert2"
import moment from 'moment'
import { smoothScroll, formatNumber, img, commingSoonFnc, isStartEvent, inGame } from 'components/common'
class HomeView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: null,
      isMobile: false,
    }
  }
  handleClosePopup() {
    this.setState({ modal: null })
    $('body').removeClass('modal-open');
  }
  handleOpenPopup(modal) {
    this.setState({ modal: modal })
    $('body').addClass('modal-open');
  }
  componentDidMount() {
    this.props.getCurrentUser()
    //--get api
    setTimeout(() => {
      AOS.init({
        offset: 0,
        easing: 'ease-out-back',
        duration: 1500
      });
    }, 500);
    if ($(window).width() < 1023) {
      this.setState({
        isMobile: true,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.home.total_count != null && !nextProps.home.loading) {
    //   this.setState({
    //     total_count: nextProps.home.total_count,
    //   })
    // }
  }
  redirectDownload(event) {
    // fbq('track', 'CompleteRegistration');
    window.open(
      'https://fo4.garena.vn/tai-game',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  render() {
    const { modal, isMobile } = this.state
    let { home } = this.props
    return (
      <React.Fragment>
        <Header currentUser={home} parentProp={this.props} />
        <MissionSection parentProp={this.props} />
        {
          inGame != null && inGame != undefined && inGame != '' ? (
            <React.Fragment>
            </React.Fragment>
          ) : (
              <React.Fragment>
                <div className="fix-social">
                  <a target="_blank" href="http://fo4.garena.vn">{img('images/s-fo4.png')}</a>
                  <a target="_blank" href="https://www.facebook.com/officialfo4vn/">{img('images/s-fb.png')}</a>
                  <a target="_blank" href="https://www.youtube.com/channel/UCrCqu1n0H52uGETAoSmgNdQ/featured">{img('images/s-youtube.png')}</a>
                  <a target="_blank" href="https://napthe.vn/app" >
                    {img('images/s-shell.png')}
                  </a>
                </div>
                {/* <div className="home-download">
                  <a href="#" onClick={(e) => this.redirectDownload()} id="trackBtnDownload">
                    {img('images/download-now.png')}
                  </a>
                </div> */}
              </React.Fragment>
            )
        }
        <Footer />
      </React.Fragment>
    )
  }
}

export default HomeView



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js